import axios from "axios";

// Use current origin for API calls — supports custom domains (fondo.is),
// Emergent deployment URLs, and preview environments seamlessly.
export const BACKEND_URL = window.location.origin;
export const API = `${BACKEND_URL}/api`;

export const formatIcelandicNumber = (number) => {
  if (number === null || number === undefined || isNaN(number)) return "0";
  return Math.round(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const getLoanTypeLabel = (loanType) => {
  switch (loanType) {
    case 'skuldabref': return 'Skuldabref';
    case 'vedskuldabref': return 'Vedskuldabref';
    case 'kaupleigusamning': return 'Kaupleigusamningur';
    default: return loanType || 'Unknown';
  }
};

export const calculatePenaltyInterest = (paymentAmount, dueDate, penaltyRate = 15.25) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(dueDate);
  due.setHours(0, 0, 0, 0);
  
  if (today <= due) return 0;
  
  const daysOverdue = Math.floor((today - due) / (1000 * 60 * 60 * 24));
  const dailyRate = penaltyRate / 100 / 360;
  return paymentAmount * dailyRate * daysOverdue;
};

export { axios };
